import { useMediaQuery, useTheme } from "@mui/material";

const CustomHidden = ({ min = 0, max = 10000, children }) => {
  const theme = useTheme();
  const isShow = useMediaQuery(theme.breakpoints.between(min, max));
  return isShow ? children : null;
};

export default CustomHidden;
